import { Outlet } from "react-router-dom";
import Nav from "./NavAdmin";
import Footer from "../shared/Footer";
import styles from "./RootLayoutAdmin.module.css";

function RootLayoutAdmin() {
    return (
        <>
            <div className={styles["announcement-banner"]}>
                Onze site is nog onder constructie. Neem contact op via <a href="https://wa.me/32468229087" target="_blank" rel="noopener noreferrer">WhatsApp</a> of <a href="mailto:info@brandvisionx.be">mail</a> voor een demo of verder informatie.
            </div>
            <Nav />
            <main>
            {/* {navigation.state === 'loading' && <p>Loading...</p>} */}
            <Outlet />
            </main>
            <Footer />
        </>
    );
}

export default RootLayoutAdmin;